import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import SideNav from "./Sidenav";

export default function Header() {
  const [showNav, setShowNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Add scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function changeNav() {
    setShowNav(!showNav);
  }

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setShowNav(false); // Close mobile nav if open
  };

  return (
    <>
      <SideNav showNav={showNav} setShowNav={setShowNav} changeNav={changeNav} />
      <header className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/80 backdrop-blur-md shadow-sm py-4' : 'bg-primary-color py-6'
    }`}>
      <div className="container mx-auto px-6">
        <nav className="flex items-center justify-between">
          {/* Logo */}
          <NavLink
            to="/"
            className={`text-2xl font-bold tracking-tight hover:text-white duration-300 transition-colors ${
              scrolled ? 'text-neutral-900 hover:text-primary-color' : 'text-neutral-50 hover:text-neutral-900'
            }`}
          >
            HS
          </NavLink>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8 text-xl text-neutral-50">
            <button
              className={`hover:text-white duration-300 transition-colors tracking-wider font-bold ${
                scrolled ? 'text-neutral-900 hover:text-primary-color' : 'text-neutral-50 hover:text-neutral-900'
              }`}
              onClick={() => scrollToSection('projects')}
            >
              Projects
            </button>
            <button
              className={`hover:text-white duration-300 transition-colors tracking-wider font-bold ${
                scrolled ? 'text-neutral-900 hover:text-primary-color' : 'text-neutral-50 hover:text-neutral-900'
              }`}
              onClick={() => scrollToSection('contact')}
            >
              Contact
            </button>
          </div>
          

          {/* Mobile Menu Button */}

          <div className="flex md:hidden">
              {scrolled ? (
                <img
                  alt="nav-menu"
                  src="/images/svg-icons/menu-dark.svg" // Create this dark version of your menu icon
                  className={`transition-transform duration-300 ease-in ${
                    showNav ? "rotate-90" : ""
                  }`}
                  onClick={changeNav}
                />
              ) : (
                <img
                  alt="nav-menu"
                  src="/images/svg-icons/menu.svg" // Your existing light menu icon
                  className={`transition-transform duration-300 ease-in ${
                    showNav ? "rotate-90" : ""
                  }`}
                  onClick={changeNav}
                />
              )}
            </div>



        </nav>
      </div>

  

    </header>
    </>
  );
}
